import type * as React from 'react';
import { useWizard } from '../Wizard/WizardContext';

export const ShowOnLastStep: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { canNext } = useWizard();
  return canNext ? null : children;
};
